import { OrderEditDialog } from './component';

export * from './component';

export default OrderEditDialog;
